import { defineMessages } from 'react-intl';

export default defineMessages({
	lblTitle: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.title',
		defaultMessage: 'Value Document Coupons',
	},
	lblNumber: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.number',
		defaultMessage: 'Coupon Number',
	},
	lblType: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.type',
		defaultMessage: 'Coupon Type',
	},
	lblUniqueTicketNumber: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.uniqueTicketNumber',
		defaultMessage: 'Unique Ticket Number',
	},
	lblReleaseStatus: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.releaseStatus',
		defaultMessage: 'Release Status',
	},
	lblReturnStartDateTime: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.returnStartDateTime',
		defaultMessage: 'Return Start Date/Time',
	},
	lblTravelSegments: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.travelSegments',
		defaultMessage: 'Travel Segments',
	},
	lblOriginalCouponNumber: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.originalCouponNumber',
		defaultMessage: 'Original Coupon Number',
	},
	lblEligibleForRelease: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.eligibleForRelease',
		defaultMessage: 'Eligible for release',
	},
	lblNotEligibleForRelease: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.notEligibleForRelease',
		defaultMessage: 'Not eligible for release',
	},
	lblReleasedOnline: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.releasedOnline',
		defaultMessage: 'Released online',
	},
	lblReleasedOffline: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.releasedOffline',
		defaultMessage: 'Released offline',
	},
	btnCancel: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.cancel',
		defaultMessage: 'Cancel',
	},
	btnClose: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.close',
		defaultMessage: 'Close',
	},
	btnRemoveDeviceId: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.removeDeviceId',
		defaultMessage: 'Remove Device ID',
	},
	dlgRemoveDeviceIdDescription: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.removeDeviceIdDialog.description',
		defaultMessage:
			'Are you sure you want to remove the device ID from these tickets? This will stop the tickets working on the users current device.',
	},
	lblSuccess: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.success',
		defaultMessage: 'Success!',
	},
	lblPartialFailure: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.partialFailure',
		defaultMessage: 'Partial Failure!',
	},
	dlgMTicketError: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.mTicketDialog.error',
		defaultMessage: 'An error occurred. Please try again.',
	},
	lblSelect: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.select',
		defaultMessage: 'Select',
	},
	dlgMTicketPartialFailureDescription: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.mTicketDialog.partialFailureDescription',
		defaultMessage:
			'Not all device ID removals were successful. The following tickets failed:',
	},
	dlgMTicketReselectMessage: {
		id: 'app.shopping.manageBooking.valueDocumentCoupons.mTicketDialog.reselectMessage',
		defaultMessage:
			'Please close this message to reselect these tickets and try again.',
	},
});
